/* unplugin-vue-components disabled */import { render } from "./ai-message.vue?vue&type=template&id=2ee506e4&scoped=true"
import script from "./ai-message.vue?vue&type=script&lang=js"
export * from "./ai-message.vue?vue&type=script&lang=js"

import "./ai-message.vue?vue&type=style&index=0&id=2ee506e4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee506e4"],['__file',"src/components/ai-chat/ai-message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ee506e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ee506e4', __exports__)) {
    api.reload('2ee506e4', __exports__)
  }
  
  module.hot.accept("./ai-message.vue?vue&type=template&id=2ee506e4&scoped=true", () => {
    api.rerender('2ee506e4', render)
  })

}


export default __exports__